import React, { useContext } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  carouselBreakpoints,
  options as DEFAULT_CAROUSEL_OPTIONS,
} from '../../constants/builder';
import { TabsContext } from '../BuilderTabs';
import { Component as Carousel } from '../Carousel';

const CarouselContainer = styled.div`
  max-width: 100vw;
`;

export const GridCarousel = styled(Carousel)`
  display: flex;
  width: 100%;

  /* Carousel overrides to get a height of 100vh */
  .slick-slider,
  .slick-list,
  .slick-track,
  .slick-slide,
  .slick-slide > div {
    height: 100%;
  }

  .slick-track {
    margin: 0;
  }

  .slick-list {
    overflow: visible;
  }

  .slick-slide > div {
    margin-right: 12px;

    @media (min-width: ${({ theme }) => theme.breakpoints.xxxlarge}px) {
      margin-right: ${({ theme }) => theme.spacing.small}px;
    }
  }

  .slick-slider {
    width: 100%;
  }

  .slick-arrow {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: -9px;
    z-index: 1;

    &.slick-prev {
      right: 42px;
    }
  }

  .slick-disabled {
    color: ${({ theme }) => theme.colors.gray400};
  }

  @media (min-width: ${carouselBreakpoints.small + 1}px) {
    .slick-list {
      overflow: hidden;
    }
  }
`;

const BuilderGridCarousel = ({ carouselOptions, children }) => {
  const tabsContext = useContext(TabsContext);
  const options = {
    ...DEFAULT_CAROUSEL_OPTIONS(tabsContext && tabsContext.showArrowsOnMobile),
    ...carouselOptions,
  };

  return (
    <CarouselContainer>
      <GridCarousel options={options}>{children}</GridCarousel>
    </CarouselContainer>
  );
};

BuilderGridCarousel.propTypes = {
  carouselOptions: PropTypes.object,
  children: PropTypes.object,
};

export default BuilderGridCarousel;
